module.exports = __webpack_public_path__ + "static/media/Santorini-alb.78677adf.jpg";